import { apiUrl } from './config.js';

export const OAUTH_RETURN_KEY = 'wcs_oauth_return_to';

/** Remember where to land after login (path + query, same origin only). */
export function setLoginReturnTo(pathWithQuery) {
  try {
    if (typeof pathWithQuery !== 'string' || !pathWithQuery.startsWith('/')) return;
    sessionStorage.setItem(OAUTH_RETURN_KEY, pathWithQuery);
  } catch {
    // ignore
  }
}

/** @returns {string} path to navigate to */
export function consumeLoginReturnTo() {
  try {
    const p = sessionStorage.getItem(OAUTH_RETURN_KEY);
    sessionStorage.removeItem(OAUTH_RETURN_KEY);
    if (p && p.startsWith('/')) return p;
  } catch {
    // ignore
  }
  return '/dashboard';
}

export function logout() {
  localStorage.removeItem('wcs_access_token');
  localStorage.removeItem('wcs_refresh_token');
}

/** Clears token and navigates to login. */
export function clearSessionAndStartLogin() {
  logout();
  setLoginReturnTo(`${window.location.pathname}${window.location.search}`);
  window.location.assign('/');
}

/**
 * Direct login — POST credentials to the API, store the JWT locally.
 * No OAuth redirect flow needed; the user stays on cycles.social.
 */
export async function loginWithCredentials(email, password) {
  const res = await fetch(apiUrl('/api/auth/login'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Login failed (${res.status})`);
  }
  const body = await res.json();
  localStorage.setItem('wcs_access_token', body.token);
  // Persist the refresh token too so same-origin sibling apps (e.g. /time/)
  // can adopt the session and refresh it once the 7-day access token expires.
  if (body.refreshToken) localStorage.setItem('wcs_refresh_token', body.refreshToken);
  return body;
}

/**
 * Direct register — POST to the API, store the JWT locally.
 */
export async function registerWithCredentials(email, password) {
  const res = await fetch(apiUrl('/api/auth/register'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Registration failed (${res.status})`);
  }
  const body = await res.json();
  localStorage.setItem('wcs_access_token', body.token);
  if (body.refreshToken) localStorage.setItem('wcs_refresh_token', body.refreshToken);
  return body;
}

export function getAccessToken() {
  return localStorage.getItem('wcs_access_token');
}
